import { recentWishListsStyles } from "@insite/content-library/Widgets/Common/RecentWishLists";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

recentWishListsStyles.wishListCard = {
    actionAddToCartButton: {
        css: css`
            background: transparent;
            border: none;
            padding: 0;
            &:hover {
                background: none;
            }
        `,
        typographyProps: {
            size: 16,
            color: "common.accent",
        },
    },
};
recentWishListsStyles.wishListCardGridItem = {
    width: 12,
    css: css`
        padding: 0 !important;
        border: 0;
        margin: 0 1rem !important;
    `,
};
